import i18n from "i18next";
import { bugsnagNotify } from "integrations/bugsnag";

export const handleAppError = (error) => {
  console.error(error);
  bugsnagNotify(error);
};

export function getApiErrorMessage(error, fallback = "") {
  const message =
    error?.response?.data?.error ??
    error?.response?.data?.message ??
    error?.message;

  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }

  return fallback;
}

export function translateApiErrorMessage(message) {
  if (typeof message !== "string" || !message.trim()) {
    return message;
  }

  const trimmed = message.trim();

  // Match "Delivery note XYZ already exists for this tour"
  const tourExistsMatch = trimmed.match(/^Delivery note (.+) already exists for this tour$/);
  if (tourExistsMatch) {
    const [, deliveryNoteNumber] = tourExistsMatch;
    return i18n.t("Delivery note {{deliveryNoteNumber}} already exists for this tour", {
      deliveryNoteNumber,
    });
  }

  // Match "Delivery note XYZ already exists in this order"
  const orderExistsMatch = trimmed.match(/^Delivery note (.+) already exists in this order$/);
  if (orderExistsMatch) {
    const [, deliveryNoteNumber] = orderExistsMatch;
    return i18n.t("Delivery note {{deliveryNoteNumber}} already exists in this order", {
      deliveryNoteNumber,
    });
  }

  return i18n.exists(trimmed) ? i18n.t(trimmed) : trimmed;
}

